import React from 'react';
import { Header } from '../components/global/header';
import { LandingPageComponent } from '../components/entry/landingPage';
import { Footer } from '../components/global/footer';

const LandingPage = () => {
  return (
    <div>
      <Header />
      <LandingPageComponent />
      <Footer />
    </div>
  );
};

export default LandingPage;
